import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface PaginationLimitOption {
  label: number;
  value: number;
}

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  standalone: false,
})
export class PaginationComponent {
  @Input() collectionSize: number;
  @Input() page = 1;
  @Output() pageChange = new EventEmitter<number>();
  @Input() pageSize = 10;
  @Input() maxSize = 7;
  @Input() showLimitSelector = false;
  @Input() limitOptions: PaginationLimitOption[] = [
    { label: 10, value: 10 },
    { label: 25, value: 25 },
    { label: 50, value: 50 },
  ];
  @Output() limitChange = new EventEmitter<number>();

  changeLimit(limit: number) {
    this.page = 1;
    this.pageChange.emit(this.page);
    this.limitChange.emit(limit);
  }
}
